import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import TimeLinesContainerWithBoundaries from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/components/InventoryAvailabilitySpoiler/TimeLinesContainerWithBoundaries'

import { getDatesWithInventoryOverlap } from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/validation/noOverlappingGamTargetingPerInventoryPerDay'
import { getInventoryItemId } from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'
import getInventoryAvailabilityTimelineData from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/components/InventoryAvailabilitySpoiler/helpers/getInventoryAvailabilityTimelineData'
import { calculateRemainingDays } from '../../helpers'

import { lineItemsSelector } from '../../../../../../../../modules/selectors/lineItems'
import { rightSelector } from '../../../../../../../../modules/selectors/rights'

import { environmentTypes } from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/fields'

import useStyles from './styles'

const InventoryAvailabilityTimelines = ({ inventory }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const existingLineItems = useSelector(lineItemsSelector)
  const right = useSelector(rightSelector)

  const { timelineStartDate, timelineEndDate } = useMemo(() => getInventoryAvailabilityTimelineData(right), [right])

  const remainingDays = useMemo(() => {
    return calculateRemainingDays({
      right,
      existingLineItems,
      inventory
    })
  }, [right, existingLineItems, inventory])

  const timelinesList = useMemo(() => {
    const videoConflictDates = getDatesWithInventoryOverlap({
      existingLineItems,
      proposedInventoryIds: inventory.map(item => getInventoryItemId(item)),
      environmentType: environmentTypes.VIDEO_PLAYER
    })
    const displayConflictDates = getDatesWithInventoryOverlap({
      existingLineItems,
      proposedInventoryIds: inventory.map(item => getInventoryItemId(item)),
      environmentType: environmentTypes.BROWSER
    })

    return [
      {
        id: 'video',
        conflictDates: videoConflictDates,
        name: inventory[0].name,
        label: (
          <div>
            {`Video `}
            <strong>{`(${remainingDays.videoRemainingDays}/${remainingDays.totalDays})`}</strong>
          </div>
        )
      },
      {
        id: 'display',
        conflictDates: displayConflictDates,
        name: inventory[0].name,
        label: (
          <div>
            {`Display `}
            <strong>{`(${remainingDays.displayRemainingDays}/${remainingDays.totalDays})`}</strong>
          </div>
        )
      }
    ]
  }, [inventory, existingLineItems, remainingDays])

  return (
    <>
      <h5 className={classes.availabilityContainerTitle}>{t('Available dates')}</h5>
      <TimeLinesContainerWithBoundaries
        timelinesList={timelinesList}
        startDate={timelineStartDate}
        endDate={timelineEndDate}
        className={classes.timelinesContainer}
      />
    </>
  )
}

InventoryAvailabilityTimelines.propTypes = {
  inventory: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired
    })
  ).isRequired
}

export default InventoryAvailabilityTimelines
